/**
 * Item Code Formatting Utilities
 * Ensures consistent uppercase formatting across the application
 */

/**
 * Format item code to uppercase
 * @param {string} code - The item code to format
 * @returns {string} - Uppercase item code, or 'N/A' if not provided
 */
export const formatItemCode = (code) => {
  if (!code || typeof code !== 'string') {
    return 'N/A';
  }
  return code.trim().toUpperCase();
};

/**
 * Format item code for display (uppercase)
 * @param {string} code - The item code
 * @returns {string} - Formatted uppercase code
 */
export const displayItemCode = (code) => {
  return formatItemCode(code);
};

/**
 * Format item code for file names and downloads
 * @param {string} code - The item code
 * @returns {string} - Uppercase code suitable for filenames
 */
export const formatItemCodeForFilename = (code) => {
  return formatItemCode(code).replace(/\s+/g, '_');
};

const itemCodeFormatter = {
  formatItemCode,
  displayItemCode,
  formatItemCodeForFilename
};

export default itemCodeFormatter;
